import { FormControl, InputLabel, Select, SelectProps } from "@mui/material";
import { SelectInputProps } from "@mui/material/Select/SelectInput";
import { FC } from "react";

interface StyledSelectProps {
  label: string;
  onChange: SelectInputProps["onChange"];
  value: SelectProps["value"];
  onBlur?: () => void;
  error: boolean;
  children: React.ReactNode;
}

const StyledSelect: FC<StyledSelectProps> = ({
  label,
  onChange,
  value,
  onBlur,
  error,
  children,
}) => {
  return (
    <FormControl sx={{ marginTop: 1 }}>
      <InputLabel htmlFor="outlined-adornment" error={error}>
        {label}
      </InputLabel>
      <Select
        onChange={onChange}
        value={value}
        onBlur={onBlur}
        label="Ville"
        error={error}
      >
        {children}
      </Select>
    </FormControl>
  );
};

export default StyledSelect;
